<template>
  <section
    v-if="variants.v2 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); 
    `"
  >
    <div class="tw-w-full">
      <div class="tw-mb-16 tw-flex tw-flex-col tw-items-center tw-self-center tw-text-center">
        <div v-if="vars.titleHtml" v-html="vars.titleHtml"></div>
      </div>
      <div class="tw-w-full !tw-text-white">
        <Swiper
          @slideChange="onSlideChange"
          @swiper="onSwiper"
          :pagination="false"
          :centered-slides="true"
          :center-insufficient-slides="true"
          :space-between="15"
          effect="fade"
          :loop="true"
          :clickable="true"
          :breakpoints="{
            320: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
            1536: {
              slidesPerView: 7,
              spaceBetween: 40,
            },
          }"
          class="social-swiper tw-self-star tw-w-full"
        >
          <SwiperSlide v-for="(post, index) in instagram_posts?.content_list" :key="index">
            <div
              v-if="post.is_deleted === false && post.is_hidden === false"
              @click="openPopup(post, true)"
              class="no-hover shine-effect tw-group tw-relative tw-basis-1/3 tw-overflow-hidden tw-transition-all tw-duration-500 hover:tw-cursor-pointer"
            >
              <LibraryImage
                :w-ratio="9"
                :h-ratio="16"
                :src="post.thumbnail_url"
                style="border-radius: var(--rounded)"
              />

              <video
                v-if="post.media_type === 'VIDEO'"
                :src="post.media_url"
                class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-100"
                style="border-radius: var(--rounded)"
                muted
                loop
                autoplay
                playsinline
              ></video>

              <div
                class="shine tw-absolute tw-inset-0 tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-30"
                style="border-radius: var(--rounded)"
              ></div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div class="mt-60 md:mt-30 tw-flex tw-items-center tw-justify-center">
          <button
            @click="swiper.slideNext()"
            class="sliderNav n-link !tw-bg-transparent !tw-text-white"
            style="border-color: #ef787c !important"
          >
            <i class="icon-left-arrow"></i>
          </button>
          <button
            @click="swiper.slideNext()"
            style="border-color: #ef787c !important"
            class="sliderNav ml-20 n-link !tw-bg-transparent !tw-text-white"
          >
            <i class="icon-right-arrow"></i>
          </button>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v3 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="{ backgroundColor: `var(--c-${vars.backgroundColor})` }"
  >
    <div
      class="container tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-6 tw-text-black lg:tw-max-w-none lg:tw-flex-row-reverse lg:tw-gap-10 xl:tw-gap-12"
    >
      <!-- Media Column -->
      <div class="tw-relative tw-w-full lg:tw-flex-[1_1_55%]">
        <!-- Main image or video with gold border styled as a decorative element rather than full border -->
        <div class="tw-relative">
          <!-- Gold border as a decorative element -->

          <!-- Image or video content -->
          <NuxtImg v-if="vars.photoImage && !vars.videoUrl" :src="vars.photoImage" class="tw-h-auto tw-w-full" />
          <library-iframe v-else-if="vars.videoUrl" :src="vars.videoUrl" />
        </div>
      </div>

      <!-- Content Column -->
      <div class="tw-mt-8 tw-flex tw-flex-[1_1_45%] tw-flex-col tw-gap-6 lg:tw-ml-10 lg:tw-mt-0 lg:tw-gap-8">
        <!-- Title -->
        <h2 class="tw-flex tw-flex-row tw-flex-wrap" :style="{ color: `var(--c-${vars.textColor})` }">
          {{ vars.titleText }}
        </h2>

        <!-- Descriptions -->
        <div v-if="descriptions" class="tw-flex tw-max-w-2xl tw-flex-col tw-gap-4">
          <p
            v-for="(item, idx) in descriptions"
            :key="`desc-${idx}`"
            class="tw-whitespace-normal"
            :style="{ color: `var(--c-${vars.textColor})` }"
          >
            {{ item.description }}
          </p>
        </div>

        <!-- Buttons -->
        <div v-if="buttons" class="tw-mt-6 tw-flex tw-flex-col tw-items-start tw-gap-1">
          <nuxt-link
            v-for="(button, idx) in buttons"
            :key="`btn-${idx}`"
            :to="button.link"
            :class="[buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto', `n-${button.type}`]"
          >
            {{ button.label }}
            <span v-if="button.type === 'arrow'"
              ><svg width="23" height="8" viewBox="0 0 23 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M22.3536 4.35355C22.5488 4.15829 22.5488 3.84171 22.3536 3.64645L19.1716 0.464466C18.9763 0.269204 18.6597 0.269204 18.4645 0.464466C18.2692 0.659728 18.2692 0.976311 18.4645 1.17157L21.2929 4L18.4645 6.82843C18.2692 7.02369 18.2692 7.34027 18.4645 7.53553C18.6597 7.7308 18.9763 7.7308 19.1716 7.53553L22.3536 4.35355ZM0 4V4.5H22V4V3.5H0V4Z"
                  fill="#8FBB54"
                />
              </svg>
            </span>
          </nuxt-link>
        </div>
      </div>
    </div>

    <div class="tw-w-full !tw-text-white">
      <Swiper
        @slideChange="onSlideChange"
        @swiper="onSwiper"
        :pagination="false"
        :centered-slides="true"
        :center-insufficient-slides="true"
        :space-between="15"
        effect="fade"
        :loop="true"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
          1536: {
            slidesPerView: 7,
            spaceBetween: 40,
          },
        }"
        class="social-swiper tw-self-star tw-w-full"
      >
        <SwiperSlide v-for="(post, index) in instagram_posts?.content_list" :key="index">
          <div
            v-if="post.is_deleted === false && post.is_hidden === false"
            @click="openPopup(post, true)"
            class="no-hover shine-effect tw-group tw-relative tw-basis-1/3 tw-overflow-hidden tw-transition-all tw-duration-500 hover:tw-cursor-pointer"
          >
            <LibraryImage :w-ratio="9" :h-ratio="16" :src="post.thumbnail_url" style="border-radius: var(--rounded)" />

            <video
              v-if="post.media_type === 'VIDEO'"
              :src="post.media_url"
              class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-100"
              style="border-radius: var(--rounded)"
              muted
              loop
              autoplay
              playsinline
            ></video>

            <div
              class="shine tw-absolute tw-inset-0 tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-30"
              style="border-radius: var(--rounded)"
            ></div>
          </div>
        </SwiperSlide>
      </Swiper>
      <div class="mt-60 md:mt-30 tw-flex tw-items-center tw-justify-center">
        <button @click="swiper.slideNext()" class="sliderNav n-link !tw-bg-transparent !tw-text-white">
          <i class="icon-left-arrow"></i>
        </button>
        <button @click="swiper.slideNext()" class="sliderNav ml-20 n-link !tw-bg-transparent !tw-text-white">
          <i class="icon-right-arrow"></i>
        </button>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import Popup from '~/components/common/popup/Popup.vue';

export default defineNuxtComponent({
  components: { Popup },

  mixins: [ComponentMixin],

  data() {
    return {
      selectedPost: null,
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      popupConfig: {
        isActive: false,
      },
      isVisible: false,
      instagram_posts: null,
    };
  },

  methods: {
    openPopup(post = null, value = false) {
      if (post) {
        this.selectedPost = post;
        this.popupConfig.isActive = value;
      }
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (this.variant === 'v1') {
        if (!this.swiper) return;
        const isAtStart = this.swiper.isBeginning;
        const isAtEnd = this.swiper.isEnd;
        if (isAtStart) this.canPaginateBack = false;
        else this.canPaginateBack = true;
        if (isAtEnd) this.canPaginateNext = false;
        else this.canPaginateNext = true;
      } else if (this.variant === 'v2') {
        if (!this.swiper) return;
        this.canPaginateBack = true;
        this.canPaginateNext = true;
      }
    },
  },
  created() {
    this.instagram_posts = this.parseFormV2(this.vars.socialInstagramPosts);
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>

<style scoped>
/* Centered slides için özel stil */
.social-wall-swiper {
  overflow: visible !important;
}

.social-wall-swiper :deep(.swiper-wrapper) {
  align-items: center;
}

.social-wall-swiper :deep(.swiper-slide) {
  width: 200px !important;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.6;
}

/* Merkezdeki aktif slide */
::v-deep(.swiper-slide) {
  transition: all 0.3s;
}

::v-deep(.swiper-slide-active) {
  transform: scale(1.1);
}

::v-deep(.swiper) {
  overflow: unset !important;
}

.social-wall-swiper :deep(.swiper-slide-active) > div {
  transform: scale(1.25);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

/* Aktif kart için sürekli shine efekti */
.social-wall-swiper :deep(.swiper-slide-active) .shine {
  opacity: 0.2 !important;
  animation: shine-animation 3s infinite;
}

@keyframes shine-animation {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Shine efekti için gradient */
.shine::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%);
  transform: rotate(45deg);
}

/* Responsive düzenlemeler */
@media (max-width: 1024px) {
  .social-wall-swiper :deep(.swiper-slide) {
    width: 150px !important;
  }

  .social-wall-swiper :deep(.swiper-slide-active) {
    width: 180px !important;
  }

  .social-wall-swiper :deep(.swiper-slide-active) > div {
    transform: scale(1.2);
  }
}

/* Orijinal stiller aynen korundu */
@media (hover: none) {
  .no-hover .shine-effect {
    filter: none;
  }

  .no-hover .shine {
    opacity: 20%;
  }

  .no-hover .card-icon-v1 {
    opacity: 100%;
    pointer-events: auto;
    transform: translateY(0px);
  }
}

@media (min-width: 700px) and (max-width: 1400px) {
  ::v-deep(.pm-modal-wrapper) {
    width: 95% !important;
  }
}

@media (min-width: 1401px) {
  ::v-deep(.pm-modal-wrapper) {
    width: 60% !important;
  }
}
</style>
